import React from 'react';

export default () => (
  <svg width="32" height="16" viewBox="0 0 32 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M31.2071 8.70711C31.5976 8.31658 31.5976 7.68342 31.2071 7.29289L24.8431 0.928932C24.4526 0.538408 23.8195 0.538408 23.4289 0.928932C23.0384 1.31946 23.0384 1.95262 23.4289 2.34315L29.0858 8L23.4289 13.6569C23.0384 14.0474 23.0384 14.6805 23.4289 15.0711C23.8195 15.4616 24.4526 15.4616 24.8431 15.0711L31.2071 8.70711ZM0.5 9H30.5V7H0.5V9Z" fill="white"/>
  </svg>
);